var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.$t("createAudit"),
      rightMethod: _vm.onSubmitted,
      rightButtonText: _vm.$t("submit"),
      hasAlert: "",
      medium: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs6: "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.warehousesSites,
                            "item-text": "siteName",
                            "item-value": "key",
                            rules: [_vm.fieldIsRequired()],
                            label: _vm.$t("warehouseSite")
                          },
                          model: {
                            value: _vm.siteKey,
                            callback: function($$v) {
                              _vm.siteKey = $$v
                            },
                            expression: "siteKey"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      [
                        _c("v-textarea", {
                          attrs: { label: _vm.$t("note"), outline: "" },
                          model: {
                            value: _vm.note,
                            callback: function($$v) {
                              _vm.note = $$v
                            },
                            expression: "note"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71e03718", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71e03718","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WarehouseAuditCreatePopup.vue
// module id = null
// module chunks = 